import { parsePhoneNumberFromString } from "libphonenumber-js";
import * as Yup from "yup";

/** Form values are E.164; local numbers default to Brazil, explicit + is preserved. */
export function identityPhone(value: string | null | undefined): string {
  if (!value?.trim()) return "";
  const raw = value.trim();
  const digits = raw.replace(/\D/g, "");
  const candidate = raw.startsWith("+") ? raw
    : [10, 11].includes(digits.length) ? "+55" + digits : "+" + digits;
  return parsePhoneNumberFromString(candidate)?.number ?? raw;
}

export function isValidCpf(value: string): boolean {
  if (!/^(\d{11}|\d{3}\.\d{3}\.\d{3}-\d{2})$/.test(value)) return false;
  const digits = value.replace(/\D/g, "");
  if (/^(\d)\1{10}$/.test(digits)) return false;
  for (const length of [9, 10]) {
    let sum = 0;
    for (let i = 0; i < length; i++) sum += Number(digits[i]) * (length + 1 - i);
    const remainder = sum % 11;
    if (Number(digits[length]) !== (remainder < 2 ? 0 : 11 - remainder)) return false;
  }
  return true;
}

export function optionalCpf() {
  return Yup.string().nullable().optional().test("cpf", "O CPF informado não é válido.", value => !value || isValidCpf(value));
}
